import { render } from "./LanguageSelectionDialog.vue?vue&type=template&id=d7181f76&ts=true"
import script from "./LanguageSelectionDialog.vue?vue&type=script&lang=ts"
export * from "./LanguageSelectionDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__